
/**
 * Find the objects within the given object which match the criteria of having
 * a specific value for a specific key.
 *
 * Returns a new object containing the objects that passed the filter
 *
 * @example filterObjectByKeyValue( products, 'color', 'Blue' )
 *
 * @param   {Object}   obj          Object to filter
 * @param   {String}   filterKey    Property key to check
 * @param   {String}   filterValue  Property value to check
 * @param   {Boolean}  filterValue  Reverse the filter, returning items that DON'T pass the filter
 *
 * @return  {Object}                Filtered object, containing only the objects that matched the criteria
 */
export function filterObjectByKeyValue( obj, filterKey, filterValue, reverse = false )
{
	const foundObjects = {};

	Object.keys( obj ).forEach( oKey =>
	{
		const curr = obj[oKey];

		const matchesFilter = ( Object.prototype.hasOwnProperty.call( curr, filterKey ) && curr[filterKey] === filterValue );

		if ( ( matchesFilter && !reverse ) || ( !matchesFilter && reverse ) )
		{
			Object.assign( foundObjects, { [oKey] : curr } );
		}
	});

	return foundObjects;
}
